import type { FC } from 'react';
import { SOCIAL_ICON_PATHS } from '../constants/socialIconPaths';
import type { SocialPlatform } from '@/features/profile/types/profile.types';

interface SocialIconProps {
    platform: SocialPlatform;
    className?: string;
}

/**
 * Simple monochrome social media icon component
 * Renders SVG paths from socialIconPaths.ts with uniform styling
 */
export const SocialIcon: FC<SocialIconProps> = ({ platform, className = '' }) => {
    const pathData = SOCIAL_ICON_PATHS[platform];

    if (!pathData) {
        return null;
    }

    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            className={className}
            fill='currentColor'
        >
            <path d={pathData} />
        </svg>
    );
};
